module.exports = __webpack_public_path__ + "media/images/ppt-icon-3d5f9a1a2b673202e2787bfdce638775.png";